const isDev = process.env.NODE_ENV === 'development'

export const log = (message: string, err?: unknown) => {
  if (isDev) {
    console.log(`${message}`, err ? err : '')
  }
}
